<template>
  <v-container fluid>
    <v-card outlined style='border-radius: 5px'>
      <v-card-title primary-title class='white py-1 justify-start'>
        <div>
          <span class="title-card">{{title}} 💰</span>
        </div>
      </v-card-title>
      <card-loading-transparent v-if="loading"/>
      <v-card-text v-if="no_data || !chart_ready">
        <v-alert v-if="no_data && !loading" type="info" :value="true" class="mt-5">
          Sem nenhum registro por enquanto
        </v-alert>
      </v-card-text>
      <v-card-text style="height: 230px" v-if="chart_ready && !loading && !no_data">
        <bar-chart v-if="chart_ready && !loading && !no_data" style=" height: 100%; width:100%" :chart-data="chart_data" :options="chart_options"></bar-chart>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
  ]
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'ExpensesByCategory',
  components: {
    BarChart: () => import('@/components/charts/BarChart.vue'),
  },
  props: {
    start_date: {
      type: String,
      default: ()=>null
    },
    end_date: {
      type: String,
      default: ()=>null
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    background_color: {
      type: String,
      default: null
    },
    movement_kind: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    width: 5,
    radius: 10,
    padding: 20,
    lineCap: 'round',
    gradient: gradients[5],
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    gradientDirection: 'top',
    gradients,
    fill: false,
    type: 'trend',
    autoLineWidth: false,

    chart_data: {
      datasets: [
        {
          data: [],
          backgroundColor: '', 
          borderColor: [],
          borderWidth: 2,
          hoverBackgroundColor: [],
          label: 'Entradas',
          helper: 'income'
        },
        {
          data: [],
          backgroundColor: '', 
          borderColor: [],
          borderWidth: 2,
          hoverBackgroundColor: [],
          label: 'Saídas',
          helper: 'outcome'
        },
      ],
      labels: [], // serão os meses
    },
    chart_options: {
      height: '10px', 
      width: '500px', 
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 20
        }
      },
      plugins:{
        datalabels: {
          anchor: 'end',
          align: 'top',
          clamp: true,
          offset: -5,
          // rotation: 90,
          color: function(ctx) {
            var is_sell = ctx.chart.data.labels[ctx.dataIndex].includes('Ab')
            return is_sell ? 'black' : 'black'
          },
          font: {
            weight: 'bold',
            size: 15
          },
          formatter: function(value, context) {
            return value>0? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : ''
          }
        }
      },
      events: ['click', 'mousemove'],
      // onClick: (e)=> {
      //   this.handleClick(e)
      // },
      // cornerRadius: 15,
      scales: {
        yAxes: [{
          display: true,
          stacked: false,
          ticks: {
            fontSize: 14
          }
        }],
        xAxes: [{
          stacked: false,
          ticks: {
            fontSize: 15
          }
          // barPercentage: 0.5,
          // categoryPercentage: 1.0
        }],
      },
      legend:{
        display: true,
        position: 'bottom',
      },
      tooltips: {
        enabled: true,
        mode: 'index',
        callbacks: {
          label: function(tooltipItems, data) { 
            return  data.datasets[tooltipItems.datasetIndex].label+ ': ' + tooltipItems.yLabel.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
          },
        }
      },
    },

    historic_data: {},
    chart_ready: false,
  }),

  methods: {
    getData(kind='income_outcome_historic'){
      let filter = {
        movement_kind: this.movement_kind, 
        start_date: this.start_date, 
        end_date: this.end_date
      }
      if (this.activeCompanyId){
        this.loading = true
        Api.Dashboard.showByCompany(this.activeCompanyId, kind, filter).then(r=>r.data).then(d=>{
        // d = d.top_shipping_open
        this.historic_data = {...d}
        this.loadChart()
      }).catch(err=> {
        const notification = {
          msg: err,
          type: 'error',
        }
        this.addNotification(notification)
      }).finally(()=>{
        this.loading = false
        // setTimeout(()=>this.loading = false, 1950)
      })

      }
    },
    loadChart() {
      this.chart_ready = false

      this.chart_data.labels = [...this.historic_data.months.map(d=>d.toUpperCase())]

      let map = this.chart_data.datasets.map( ({helper}) => helper) // ['income', 'outcome']
      map.forEach( (k, k_idx) => {
        this.chart_data.datasets[k_idx].data = [...this.historic_data.data[k]]
        this.chart_data.datasets[k_idx].backgroundColor = this.background_color//.map(d=> Math.round(d))
      })
      // let max_data = 0
      // this.chart_data.datasets.forEach(v => {
      //   max_data = [...v.data]
      // })
      // max_data = max_data.flat()
      // max_data = max_data.sort().slice(-1)
      // this.chart_options.scales.yAxes[0].ticks.max = Math.ceil(max_data * 1.15)

      // for (let idx = 0; idx < this.historic_data.data.length; idx++) {
      //   const {kind, monthly_count} = this.historic_data.data[idx];
      //   const ds_idx = this.chart_data.datasets.findIndex( ({helper}) => helper == kind)
      //   this.chart_data.datasets[ds_idx].data = [...monthly_count]
      // }
      
      
      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },

    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    no_data() {
      if (this.chart_ready && this.chart_data.labels.length == 0 ){
        return true
      }
      return false 
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getData()
  },
  watch: {
    activeCompanyId(){
      this.getData()
    },
    start_date(){
      this.getData()
    },
  },

}
</script>

<style lang="scss" scoped>

</style>